import React from "react";
import { Star } from "lucide-react";

export const Stars = ({ value = 5, size = 15, className = "", light = false, testId }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} / 5`} data-testid={testId}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={size} strokeWidth={1.5}
        className={i <= Math.round(value) ? (light ? "text-sand-brand fill-sand-brand" : "text-ocean fill-ocean") : (light ? "text-ivory/30" : "text-ocean/20")} />
    ))}
  </span>
);
